import React, { useContext, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '../../../CommonComponents/OPL/Button/Button';
import { StatusViewsContext } from '../StatusViews.context';
import {
  Actions,
  BigIcon,
  CenteredContainer,
  Description,
  Title,
  Wrapper,
} from '../StatusViews.styles';
import {
  selectIsUserAdvisor,
  selectIsUserClient,
} from '../../../CommonSelectors/CommonAreaSelector';
import { CancelDialog } from '../../../ApexOPL/AccountOpening/components/CancelDialog/CancelDialog';
import { fetchNetWorthData } from '../../../ContextualSidebar/NetWorthSidebar/NetWorthSidebarActions';

export const Draft = () => {
  const { clientId, accountId } = useContext(StatusViewsContext);

  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);

  const isUserClient = useSelector(selectIsUserClient);
  const isUserAdvisor = useSelector(selectIsUserAdvisor);

  const dispatch = useDispatch();

  return (
    <>
      <Wrapper>
        <CenteredContainer>
          <BigIcon className="far fa-history" />
          <Title>Your account is pending</Title>

          {isUserClient && (
            <>
              <Description>Please complete your application.</Description>

              <Actions>
                <Button
                  onClick={() => {
                    ADV.util.Router.go2('AccountOpening', {
                      clientId,
                      draftId: accountId,
                    });
                  }}
                >
                  Resume Application
                </Button>

                <Button variant="secondary" onClick={() => setIsCancelModalOpen(true)}>
                  Cancel
                </Button>
              </Actions>
            </>
          )}

          {isUserAdvisor && (
            <Actions>
              <Button
                onClick={() => {
                  ADV.util.Router.go2('AccountOpening', {
                    clientId,
                    draftId: accountId,
                  });
                }}
              >
                Edit Application
              </Button>
            </Actions>
          )}
        </CenteredContainer>
      </Wrapper>

      {isCancelModalOpen && (
        <CancelDialog
          clientId={clientId}
          draftId={accountId}
          onClose={() => setIsCancelModalOpen(false)}
          onSuccess={() => {
            dispatch(fetchNetWorthData(clientId));
            ADV.util.Router.go2('Transactions', { clientId, accountId: 0 });
          }}
        />
      )}
    </>
  );
};
